<template>
<div id="Home" v-if="$auth('home.page')" :class="$auth('ADMIN') ? 'admin' : 'operator'">
	<OverviewStat :time="time" pos="home"/>

	<a-row :gutter="[16, 16]" style="margin-top: 8px; display: flex; flex-wrap: wrap">
		<a-col :xs="24" :sm="24" :xl="16">
			<div class="statistic-panel group-statistic-container">
				<div class="panel-title">
					<div class="title-area">
						<img class="title-img" src="@/assets/images/home/group_stat.png" />
						{{ $Filter.statTimeTypeFilter(time.type) }}营收统计
					</div>
					<div class="btn-area"><TimeRangePicker type="year" @change="handleTimeChange" /></div>
				</div>
				<a-row class="panel-content">
					<a-col :xs="customization ? 24 : 8"
						:sm="customization ? ($auth('ADMIN') ? 24 : 12) : 7"
						:lg="$auth('ADMIN') ? 24 : 12"
						:xxl="$auth('ADMIN') ? 15 : 12"
						v-if="$auth('stat.income.energy')">
						<CountStatistic :time="time" />
					</a-col>
					<a-col :xs="$auth('stat.income.energy') ? (customization ? 24 : 16) : 24"
						:sm="$auth('stat.income.energy') ? (customization ? ($auth('ADMIN') ? 24 : 12) : 17) : 24"
						:lg="$auth('ADMIN') ? 24 : 12"
						:xxl="$auth('ADMIN') ? 9 : 12">
						<PaywayStatistic :time="time" />
					</a-col>
					<a-col :span="24">
						<GroupStatistic :time="time" />
					</a-col>
				</a-row>
			</div>
		</a-col>
		<a-col :xs="24" :sm="24" :xl="8">
			<RankStatistic :byDetail="$auth('OPERATOR')" />
		</a-col>
	</a-row>
	<!-- <SuccessRateStatistic v-if="$auth('ADMIN')"/> -->
</div>
</template>

<script>
import Core from '../core';
export default {
	name: 'Home',
	components: {
		TimeRangePicker: () => import('@/components/statistic/TimeRangePicker.vue'),
		OverviewStat: () => import('@/components/statistic/OverviewStat.vue'),
		CountStatistic: () => import('@/components/statistic/CountStatistic.vue'),
		GroupStatistic: () => import('@/components/statistic/GroupStatistic.vue'),
		PaywayStatistic: () => import('@/components/statistic/PaywayStatistic.vue'),
		RankStatistic: () => import('@/components/statistic/RankStatistic.vue'),
		SuccessRateStatistic: () => import('@/components/statistic/SuccessRateStatistic.vue'),
	},
	data() {
		return {
			time: {
				type: 1,
				value: '',
				begin_time: '',
				end_time: '',
			},
		};
	},
	computed: {
		customization() {
			if (this.$auth('ADMIN')) {
				return true;
			}
			if (Core.Const.STAT.CUSTOM_OPERATOR.includes(Core.Data.getUser().id)) {
				return true;
			}
			return Core.Util.auth('stat.home.transaction.amount');
		},
	},
	mounted() {
		let search = window.location.search;
		if (search && search.includes('auth_code') && search.includes('expires_in')) {
			console.log('window.href', window.location.origin + '/#/operator/wx-platform' + search);
			window.location.href = window.location.origin + '/#/operator/wx-platform' + search;
		}
	},
	methods: {
		// 时间转换 (第一次在组件内部时间驱动)
		handleTimeChange(type, time, {begin_time, end_time} = {}) {
			this.time = { type: type, value: time, begin_time, end_time};
		},
	},
};
</script>